import Types from "./Types";

function normalizeList(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  return [];
}

const INITIAL_STATE = {
  available: [],
  upcoming: [],
  history: [],
  isLoadingAvailable: false,
  isLoadingUpcoming: false,
  isLoadingHistory: false,
  applyLoading: false,
};

export default function studentOfficeHoursReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_STUDENT_OFFICE_HOURS_SUCCESS: {
      return {
        ...state,
        available: normalizeList(payload),
      };
    }
    case Types.GET_UPCOMING_OFFICE_HOURS_SUCCESS: {
      return {
        ...state,
        upcoming: normalizeList(payload),
      };
    }
    case Types.GET_OFFICE_HOURS_HISTORY_SUCCESS: {
      return {
        ...state,
        history: normalizeList(payload),
      };
    }
    case Types.SET_STUDENT_OFFICE_HOURS_LOADING:
      return { ...state, isLoadingAvailable: !!payload };
    case Types.SET_UPCOMING_OFFICE_HOURS_LOADING:
      return { ...state, isLoadingUpcoming: !!payload };
    case Types.SET_OFFICE_HOURS_HISTORY_LOADING:
      return { ...state, isLoadingHistory: !!payload };
    case Types.SET_APPLY_OFFICE_HOUR_LOADING:
      return { ...state, applyLoading: !!payload };
    default:
      return state;
  }
}
